export const verifyBankAccount = async ({
  sessionId,
  loanNumber,
  abaNumber,
  accountNumber,
}) => {
  try {
    const url = process.env.REACT_APP_EXTERNAL_INVOKE_URL_REGISTRATION_STEP_1;
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname; 
    const afterCurrent = path.split("/current/")[1];
    const newUrl = `${parsedUrl.origin}/current/bankaccountverify`;
    const response = await fetch(
      //'https://wr62dgjpeg.execute-api.us-east-1.amazonaws.com/current/bankaccountverify',
      newUrl,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_EXTERNAL_API_KEY_VALUE, //'jfdVQdU7MU3UlPqsLM6dL7BqEHtY6yc42sp6JfwR'
        },
        body: JSON.stringify({
          session_id: sessionId,
          loan_number: loanNumber,
          aba_number: abaNumber,
          account_number: accountNumber,
        }),
      }
    );

    if (!response.ok) {
      throw new Error('Bank verification API failed');
    }

    const data = await response.json();

    // ⚠️ Adjust if backend response shape differs
    return data?.result_value;
  } catch (error) {
    console.error('verifyBankAccount error:', error);
    return false;
  }
};


// validate loan number
export const verifyLoanNumber = async ({
  loanNumber
}) => {
  try {
    const url = process.env.REACT_APP_EXTERNAL_INVOKE_URL_REGISTRATION_STEP_1;
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname; 
    const afterCurrent = path.split("/current/")[1];
    const newUrl = `${parsedUrl.origin}/current/loanverify`;
    
    const response = await fetch(
      //'https://wr62dgjpeg.execute-api.us-east-1.amazonaws.com/current/loanverify',
      newUrl,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_EXTERNAL_API_KEY_VALUE, //'jfdVQdU7MU3UlPqsLM6dL7BqEHtY6yc42sp6JfwR',
        },
        body: JSON.stringify({
          loan_number: loanNumber
        }),
      }
    );

    if (!response.ok) {
      throw new Error('Loan verification API failed');
    }

    const data = await response.json();

    // ⚠️ Adjust if backend response shape differs
    return data?.result_value;
  } catch (error) {
    console.error('verifyBankAccount error:', error);
    return false;
  }
};
